import { InvoiceDetailModel, InvoiceModel, InvoiceStatus } from '@frontend/api-invoices';

export const isPaidInvoice = (invoice: InvoiceModel | InvoiceDetailModel | undefined) =>
  !!invoice &&
  !!invoice.payment &&
  (invoice.status === InvoiceStatus.Paid ||
    invoice.status === InvoiceStatus.PartiallyPaid ||
    invoice.payment?.status === 'SUCCEEDED');

export const isCanceledInvoice = (invoice: InvoiceModel | InvoiceDetailModel | undefined) =>
  !!invoice && invoice.status === InvoiceStatus.Canceled;

export const isPaidOrPendingInvoice = (invoice: InvoiceModel | InvoiceDetailModel | undefined) =>
  !!invoice && (isPaidInvoice(invoice) || isPendingInvoice(invoice));

export const isPendingInvoice = (invoice: InvoiceModel | InvoiceDetailModel | undefined) =>
  !!invoice &&
  (invoice.status === InvoiceStatus.Pending || (!!invoice.payment && invoice.payment.status === 'PENDING'));

export const isFailedInvoice = (invoice: InvoiceModel | InvoiceDetailModel | undefined) =>
  !!invoice && !!invoice.payment && invoice.payment.status === 'FAILED' && invoice.status !== InvoiceStatus.Paid;

export const isPartialPayment = (invoice: InvoiceModel | InvoiceDetailModel | undefined) =>
  !!invoice && !!invoice.payment && invoice.billedAmount - invoice.payment.paidAmount > 0;

export const isCompletelyPaid = (invoice: InvoiceModel | InvoiceDetailModel | undefined) =>
  isPaidOrPendingInvoice(invoice) && !isPartialPayment(invoice);
